import api, { handleResponse, handleError } from './api';

/**
 * Spotify search proxy for the profile-anthem picker. The Spotify app
 * credentials live server-side; this only returns slimmed track data
 * (id, name, artist, album art, preview url, spotify url).
 */
const spotifyService = {
  async searchTracks(query, limit = 10) {
    try {
      const r = await api.get(`/spotify/search?q=${encodeURIComponent(query)}&limit=${limit}`);
      return handleResponse(r);
    } catch (e) {
      return handleError(e);
    }
  },

  async getTrack(id) {
    try {
      const r = await api.get(`/spotify/tracks/${encodeURIComponent(id)}`);
      return handleResponse(r);
    } catch (e) {
      return handleError(e);
    }
  },
};

export default spotifyService;
